import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import useDynamicRefs from "use-dynamic-refs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  captchaChecked,
  pagesState,
  validateNumber,
  saveDateFrom,
  validateDate,
  formData,
  MyLibraryLogInAsync,
  myLibs,
  GetFormContextOfUseAsync,
  contextOfUse,
  ChangePOU,
  curPOU,
  curCOU,
  Uens,
  GetUENAsync,
  filterAgencyList,
  filterAgencyValue,
  GetAgency,
  cur_agency,
  GetPriceRuleAsync,
  UpdateCouData,
  shoppingCart,
  GetFormPurposeOfUseAsync,
} from "./controller";
import CurrencyFormat from "react-currency-format";
import { current } from "@reduxjs/toolkit";
import moment from "moment";

export function ArchivalForm() {
  const dispatch = useDispatch();
  const pages_state = useSelector(pagesState);
  const my_Libs = useSelector(myLibs);
  const form_Data = useSelector(formData);
  const contextOf_Use = useSelector(contextOfUse);
  const cur_POU = useSelector(curPOU);
  const cur_COU = useSelector(curCOU);
  const Uens_data = useSelector(Uens);
  const filterAgency_Value = useSelector(filterAgencyValue);
  const curagency = useSelector(cur_agency);
  const shopping_Cart = useSelector(shoppingCart);

  const [getRef, setRef] = useDynamicRefs();

  var [showViewAgency, setshowViewAgency] = useState(false);
  var toggleshowViewAgency = () => setshowViewAgency(!showViewAgency);

  var [showAccession, setshowAccession] = useState(false);
  var toggleshowAccession = () => setshowAccession(!showAccession);

  useEffect(() => {
    if (!sessionStorage.getItem("shoppingCart")) {
      // window.location.href = "./mycart";
    } else {
      dispatch(GetPriceRuleAsync());
      dispatch(GetFormContextOfUseAsync());
      dispatch(GetUENAsync());
      const redirectUrl = {
        CallBackUrl: process.env.REACT_APP_ARCHIVAL_CALLBACKURL,
      };
      dispatch(MyLibraryLogInAsync(redirectUrl));
    }
  }, []);

  const submitRequest = (e) => {
    e.preventDefault();

    if (
      getRef("recaptcha").current.getValue() &&
      pages_state.isNumberCorrect &&
      pages_state.isDateWithin3Years
    ) {
      var formData = {
        RequestorName: getRef("name").current.value,
        RequestorEmail: getRef("email").current.value,
        // requestorInternationCode: getRef("firstNo").current.value,
        RequestorMobile: getRef("lastNo").current.value,
        OrganisationName:
          cur_POU === "PV" || cur_POU === "PA"
            ? getRef("OrganisationName").current.value
            : "",
        COUCode: getRef("COUCode").current.value,
        ResearchTopic: getRef("ResearchTopic").current.value,
        Nationality: getRef("Nationality").current.value,
        UserTypeCode: cur_POU,
        Remarks: getRef("remarks").current.value,
        OtherRemarks:
          cur_COU === "OT" ? getRef("OtherRemarks").current.value : "",
        ExpectedDateOfCompletion: date === null ? null : moment(date).format("YYYY-MM-DD"),
      };
      sessionStorage.setItem("afs", JSON.stringify(formData));
      dispatch(captchaChecked(true));
      setTimeout(() => {
        window.location.href = "./archival/summary";
      }, 500);
    } else if (!getRef("recaptcha").current.getValue()) {
      dispatch(captchaChecked(false));
    }
  };

  const filterAgency = (e) => {
    dispatch(filterAgencyList(e.target.value));
  };

  const updateUEN = (name) => {
    dispatch(GetAgency(name));
    toggleshowViewAgency();
  };

  const changePou = (pou) => {
    dispatch(ChangePOU(pou));
    setTimeout(() => {
      dispatch(GetFormPurposeOfUseAsync());
    }, 100);
  };

  const [isVisible, setIsVisible] = useState(false);
  const updateCou = (e) => {
    if (e.target.value === "OT") {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
    dispatch(UpdateCouData(e.target.value));
    setTimeout(() => {
      dispatch(GetFormPurposeOfUseAsync());
    }, 100);
  };

  const verifyNumber = (e) => {
    if (e.target.value.length < 8) {
      dispatch(validateNumber(false));
    } else {
      dispatch(validateNumber(true));
    }
  };

  const [date, setDate] = useState(
    form_Data ? new Date(form_Data.ExpectedCompletionDate) : null
  );
  const [errorMessage, setErrorMessage] = useState('');
  const updateDate = date => {
    let today = new Date();
    if (date > today) {
      setDate(date);
      setErrorMessage("");
    } else if (date === null) {
      setDate(date);
      setErrorMessage("No date selected !");
    } else {
      setErrorMessage("Please pick a valid date !");
    }
  };
   const updateDate2 = date => {
    let today = new Date();
    if (date > today) {
      setDate(date);
      setErrorMessage("");
    } else if (date === null) {
      setDate(date);
      setErrorMessage("No date selected!");
    } else {
      setErrorMessage("");
    }
  };

  return (
    <section id="ArchivalForm">
      <div className="container-fluid mt-3 form">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <img src="./images/icn-OnTopSchool.png" alt="" />
                <h2 className="pageTitle mt-2 mb-3">Personal Particulars</h2>
                <div className="step">
                  <div className="breadcrumbs">
                    <ul className="steps d-flex justify-content-center align-items-center">
                      <li>
                        <img src="./images/icon1.png" alt="Step 1" />
                        <span className="theme-color">
                          <b>Cart</b>
                        </span>
                      </li>
                      <li>
                        <img src="./images/icon-form.png" alt="Step 1" />
                        <span className="theme-color">
                          <b>Form</b>
                        </span>
                      </li>
                      <li>
                        <img
                          src="./images/icon-complete-disabled.png"
                          alt="Step 2"
                        />
                        <span className="text-gray">Complete</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <form onSubmit={(e) => submitRequest(e)}>
                <div className="card overflow-hidden">
                  <div className="card-header"></div>
                  <div className="card-body d-flex justify-content-center">
                    <div className="entryForm">
                      {my_Libs && !my_Libs.isMylibsLogin && (
                        <div className="mylibs mb-5">
                          <div className="theme-color font-weight-bold text-center">
                            Click here to login with your Mylibrary ID Account
                            to retrieve your information. If you do not have an
                            account, please fill in the form below with your
                            details.
                          </div>
                          <div className="d-flex justify-content-center mt-3">
                            <a
                              className="ui-theme-btn btn-mylibrary cursor_pointer"
                              title="Login using your NLB account."
                              target="_self"
                              href={pages_state ? pages_state.dataUrl : "#"}
                            >
                              <img
                                style={{ maxHeight: "31px", width: "auto" }}
                                src="./images/nlb-logo-white.svg"
                                alt=""
                              />{" "}
                              <span className="px-1">NLB myLibrary</span>{" "}
                              <span
                                style={{ fontSize: "20px" }}
                                className="material-icons-outlined align-middle"
                              >
                                chevron_right
                              </span>{" "}
                            </a>
                          </div>
                        </div>
                      )}

                      <div className="mt-5">
                        <h3 className="theme-color text-center">
                          Requestor's Particulars
                        </h3>

                        <div className="input-group row mt-3 mb-3">
                          <label
                            htmlFor="name"
                            className="col-sm-3 col-form-label text-nowrap"
                          >
                            Name<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                form_Data
                                  ? form_Data.RequestorName
                                  : my_Libs
                                    ? my_Libs.RequestorNameFromLibs
                                    : ""
                              }
                              id="name"
                              ref={setRef("name")}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="input-group row mb-3">
                          <label
                            htmlFor="email"
                            className="col-sm-3 col-form-label text-nowrap"
                          >
                            Email<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="email"
                              className="form-control"
                              defaultValue={
                                form_Data
                                  ? form_Data.RequestorEmail
                                  : my_Libs
                                    ? my_Libs.RequestorEmailFromLibs
                                    : ""
                              }
                              ref={setRef("email")}
                              id="email"
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="input-group mb-3 row">
                          <label
                            htmlFor="LastNo"
                            className="col-sm-3 col-form-label text-nowrap"
                          >
                            Mobile No<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-9 d-flex flex-row">
                            <div className="me-3">
                              <select
                                id="firstNo"
                                style={{ minWidth: "80px" }}
                                className="form-control"
                                ref={setRef("firstNo")}
                                defaultValue={
                                  form_Data
                                    ? form_Data.requestorInternationCode
                                    : ""
                                }
                              >
                                <option value="+65">+65</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                            <div style={{ flexBasis: "100%" }}>
                              <input
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                defaultValue={
                                  form_Data
                                    ? form_Data.RequestorMobile
                                    : my_Libs
                                      ? my_Libs.RequestorMobileFromLibs
                                      : ""
                                }
                                className={
                                  pages_state && pages_state.isNumberCorrect
                                    ? "form-control w-100"
                                    : "form-control w-100 is-invalid"
                                }
                                id="lastNo"
                                autoComplete="off"
                                onBlur={(e) => verifyNumber(e)}
                                ref={setRef("lastNo")}
                                required
                              />
                              {pages_state && !pages_state.isNumberCorrect && (
                                <div className="text-danger ">
                                  <small> At least 8 digits!</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card overflow-hidden mt-3">
                  <div className="card-header"></div>
                  <div className="card-body d-flex justify-content-center">
                    <div className="entryForm">
                      <div>
                        <h3 className="theme-color text-center">
                          Archival Particulars
                        </h3>

                        <div className="input-group mb-3 row mt-3">
                          <label
                            htmlFor="Nationality"
                            className="col-sm-3 col-form-label text-wrap"
                          >
                            Nationality<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-9">
                            <select
                              defaultValue={
                                form_Data ? form_Data.Nationality : ""
                              }
                              className="form-control"
                              id="Nationality"
                              ref={setRef("Nationality")}
                              required
                            >
                              <option value="singaporean">Singaporean</option>
                              <option value="afghan">Afghan</option>
                              <option value="albanian">Albanian</option>
                              <option value="algerian">Algerian</option>
                              <option value="american">American</option>
                              <option value="andorran">Andorran</option>
                              <option value="angolan">Angolan</option>
                              <option value="antiguans">Antiguans</option>
                              <option value="argentinean">Argentinean</option>
                              <option value="armenian">Armenian</option>
                              <option value="australian">Australian</option>
                              <option value="austrian">Austrian</option>
                              <option value="azerbaijani">Azerbaijani</option>
                              <option value="bahamian">Bahamian</option>
                              <option value="bahraini">Bahraini</option>
                              <option value="bangladeshi">Bangladeshi</option>
                              <option value="barbadian">Barbadian</option>
                              <option value="barbudans">Barbudans</option>
                              <option value="batswana">Batswana</option>
                              <option value="belarusian">Belarusian</option>
                              <option value="belgian">Belgian</option>
                              <option value="belizean">Belizean</option>
                              <option value="beninese">Beninese</option>
                              <option value="bhutanese">Bhutanese</option>
                              <option value="bolivian">Bolivian</option>
                              <option value="bosnian">Bosnian</option>
                              <option value="brazilian">Brazilian</option>
                              <option value="british">British</option>
                              <option value="bruneian">Bruneian</option>
                              <option value="bulgarian">Bulgarian</option>
                              <option value="burkinabe">Burkinabe</option>
                              <option value="burmese">Burmese</option>
                              <option value="burundian">Burundian</option>
                              <option value="cambodian">Cambodian</option>
                              <option value="cameroonian">Cameroonian</option>
                              <option value="canadian">Canadian</option>
                              <option value="cape verdean">Cape Verdean</option>
                              <option value="central african">
                                Central African
                              </option>
                              <option value="chadian">Chadian</option>
                              <option value="chilean">Chilean</option>
                              <option value="chinese">Chinese</option>
                              <option value="colombian">Colombian</option>
                              <option value="comoran">Comoran</option>
                              <option value="congolese">Congolese</option>
                              <option value="costa rican">Costa Rican</option>
                              <option value="croatian">Croatian</option>
                              <option value="cuban">Cuban</option>
                              <option value="cypriot">Cypriot</option>
                              <option value="czech">Czech</option>
                              <option value="danish">Danish</option>
                              <option value="djibouti">Djibouti</option>
                              <option value="dominican">Dominican</option>
                              <option value="dutch">Dutch</option>
                              <option value="east timorese">
                                East Timorese
                              </option>
                              <option value="ecuadorean">Ecuadorean</option>
                              <option value="egyptian">Egyptian</option>
                              <option value="emirian">Emirian</option>
                              <option value="equatorial guinean">
                                Equatorial Guinean
                              </option>
                              <option value="eritrean">Eritrean</option>
                              <option value="estonian">Estonian</option>
                              <option value="ethiopian">Ethiopian</option>
                              <option value="fijian">Fijian</option>
                              <option value="filipino">Filipino</option>
                              <option value="finnish">Finnish</option>
                              <option value="french">French</option>
                              <option value="gabonese">Gabonese</option>
                              <option value="gambian">Gambian</option>
                              <option value="georgian">Georgian</option>
                              <option value="german">German</option>
                              <option value="ghanaian">Ghanaian</option>
                              <option value="greek">Greek</option>
                              <option value="grenadian">Grenadian</option>
                              <option value="guatemalan">Guatemalan</option>
                              <option value="guinea-bissauan">
                                Guinea-Bissauan
                              </option>
                              <option value="guinean">Guinean</option>
                              <option value="guyanese">Guyanese</option>
                              <option value="haitian">Haitian</option>
                              <option value="herzegovinian">
                                Herzegovinian
                              </option>
                              <option value="honduran">Honduran</option>
                              <option value="hungarian">Hungarian</option>
                              <option value="icelander">Icelander</option>
                              <option value="indian">Indian</option>
                              <option value="indonesian">Indonesian</option>
                              <option value="iranian">Iranian</option>
                              <option value="iraqi">Iraqi</option>
                              <option value="irish">Irish</option>
                              <option value="israeli">Israeli</option>
                              <option value="italian">Italian</option>
                              <option value="ivorian">Ivorian</option>
                              <option value="jamaican">Jamaican</option>
                              <option value="japanese">Japanese</option>
                              <option value="jordanian">Jordanian</option>
                              <option value="kazakhstani">Kazakhstani</option>
                              <option value="kenyan">Kenyan</option>
                              <option value="kittian and nevisian">
                                Kittian and Nevisian
                              </option>
                              <option value="kuwaiti">Kuwaiti</option>
                              <option value="kyrgyz">Kyrgyz</option>
                              <option value="laotian">Laotian</option>
                              <option value="latvian">Latvian</option>
                              <option value="lebanese">Lebanese</option>
                              <option value="liberian">Liberian</option>
                              <option value="libyan">Libyan</option>
                              <option value="liechtensteiner">
                                Liechtensteiner
                              </option>
                              <option value="lithuanian">Lithuanian</option>
                              <option value="luxembourger">Luxembourger</option>
                              <option value="macedonian">Macedonian</option>
                              <option value="malagasy">Malagasy</option>
                              <option value="malawian">Malawian</option>
                              <option value="malaysian">Malaysian</option>
                              <option value="maldivan">Maldivan</option>
                              <option value="malian">Malian</option>
                              <option value="maltese">Maltese</option>
                              <option value="marshallese">Marshallese</option>
                              <option value="mauritanian">Mauritanian</option>
                              <option value="mauritian">Mauritian</option>
                              <option value="mexican">Mexican</option>
                              <option value="micronesian">Micronesian</option>
                              <option value="moldovan">Moldovan</option>
                              <option value="monacan">Monacan</option>
                              <option value="mongolian">Mongolian</option>
                              <option value="moroccan">Moroccan</option>
                              <option value="mosotho">Mosotho</option>
                              <option value="motswana">Motswana</option>
                              <option value="mozambican">Mozambican</option>
                              <option value="namibian">Namibian</option>
                              <option value="nauruan">Nauruan</option>
                              <option value="nepalese">Nepalese</option>
                              <option value="new zealander">
                                New Zealander
                              </option>
                              <option value="ni-vanuatu">Ni-Vanuatu</option>
                              <option value="nicaraguan">Nicaraguan</option>
                              <option value="nigerien">Nigerien</option>
                              <option value="north korean">North Korean</option>
                              <option value="northern irish">
                                Northern Irish
                              </option>
                              <option value="norwegian">Norwegian</option>
                              <option value="omani">Omani</option>
                              <option value="pakistani">Pakistani</option>
                              <option value="palauan">Palauan</option>
                              <option value="panamanian">Panamanian</option>
                              <option value="papua new guinean">
                                Papua New Guinean
                              </option>
                              <option value="paraguayan">Paraguayan</option>
                              <option value="peruvian">Peruvian</option>
                              <option value="polish">Polish</option>
                              <option value="portuguese">Portuguese</option>
                              <option value="qatari">Qatari</option>
                              <option value="romanian">Romanian</option>
                              <option value="russian">Russian</option>
                              <option value="rwandan">Rwandan</option>
                              <option value="saint lucian">Saint Lucian</option>
                              <option value="salvadoran">Salvadoran</option>
                              <option value="samoan">Samoan</option>
                              <option value="san marinese">San Marinese</option>
                              <option value="sao tomean">Sao Tomean</option>
                              <option value="saudi">Saudi</option>
                              <option value="scottish">Scottish</option>
                              <option value="senegalese">Senegalese</option>
                              <option value="serbian">Serbian</option>
                              <option value="seychellois">Seychellois</option>
                              <option value="sierra leonean">
                                Sierra Leonean
                              </option>
                              <option value="slovakian">Slovakian</option>
                              <option value="slovenian">Slovenian</option>
                              <option value="solomon islander">
                                Solomon Islander
                              </option>
                              <option value="somali">Somali</option>
                              <option value="south african">
                                South African
                              </option>
                              <option value="south korean">South Korean</option>
                              <option value="spanish">Spanish</option>
                              <option value="sri lankan">Sri Lankan</option>
                              <option value="sudanese">Sudanese</option>
                              <option value="surinamer">Surinamer</option>
                              <option value="swazi">Swazi</option>
                              <option value="swedish">Swedish</option>
                              <option value="swiss">Swiss</option>
                              <option value="syrian">Syrian</option>
                              <option value="taiwanese">Taiwanese</option>
                              <option value="tajik">Tajik</option>
                              <option value="tanzanian">Tanzanian</option>
                              <option value="thai">Thai</option>
                              <option value="togolese">Togolese</option>
                              <option value="tongan">Tongan</option>
                              <option value="trinidadian or tobagonian">
                                Trinidadian or Tobagonian
                              </option>
                              <option value="tunisian">Tunisian</option>
                              <option value="turkish">Turkish</option>
                              <option value="tuvaluan">Tuvaluan</option>
                              <option value="ugandan">Ugandan</option>
                              <option value="ukrainian">Ukrainian</option>
                              <option value="uruguayan">Uruguayan</option>
                              <option value="uzbekistani">Uzbekistani</option>
                              <option value="venezuelan">Venezuelan</option>
                              <option value="vietnamese">Vietnamese</option>
                              <option value="welsh">Welsh</option>
                              <option value="yemenite">Yemenite</option>
                              <option value="zambian">Zambian</option>
                              <option value="zimbabwean">Zimbabwean</option>
                            </select>
                          </div>
                        </div>
                        <div className="input-group mb-3  row">
                          <label
                            htmlFor="pou"
                            className="col-sm-3 col-form-label text-wrap"
                          >
                            Purpose of use<span className="text-danger">*</span>
                            :
                          </label>
                          <div className="col-sm-9">
                            <label className="d-block">
                              <input
                                type="radio"
                                name="pou"
                                onChange={() => changePou("PU")}
                                checked={cur_POU && cur_POU === "PU"}
                              />{" "}
                              Personal Use
                            </label>
                            <label className="d-block">
                              <input
                                type="radio"
                                name="pou"
                                onChange={() => changePou("PV")}
                                checked={cur_POU && cur_POU === "PV"}
                                value="PV"
                              />{" "}
                              Private Organisation
                            </label>
                            <label className="d-block">
                              <input
                                type="radio"
                                name="pou"
                                onChange={() => changePou("PA")}
                                checked={cur_POU && cur_POU === "PA"}
                                value="PA"
                              />{" "}
                              Public Agency
                            </label>
                            {cur_POU && cur_POU === "PA" && (
                              <div>
                                <small className="text-danger">
                                  *Please use your agency email address if you
                                  select this option
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                        {cur_POU && cur_POU === "PV" && (
                          <div className="col row mb-3">
                            <label
                              htmlFor="OrganisationName"
                              className="col-sm-3 col-form-label text-wrap"
                            >
                              Organisation Name
                              <span className="text-danger">*</span>:
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                defaultValue={
                                  form_Data ? form_Data.OrganisationName : ""
                                }
                                className="form-control"
                                ref={setRef("OrganisationName")}
                                id="OrganisationName"
                                placeholder="The National Research Foundation"
                                autoComplete="off"
                                required
                              />
                            </div>
                          </div>
                        )}
                        {cur_POU && cur_POU === "PA" && (
                          <div
                            className="col row mb-3 position-relative"
                            style={{ zIndex: 999 }}
                          >
                            <label
                              htmlFor="OrganisationName"
                              className="col-sm-3 col-form-label text-wrap"
                            >
                              Agency Name<span className="text-danger">*</span>:
                            </label>
                            <div className="col-sm-9">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={curagency}
                                  onClick={toggleshowViewAgency}
                                  ref={setRef("OrganisationName")}
                                  id="OrganisationName"
                                  placeholder="Click me and select Agency"
                                  autoComplete="off"
                                  required
                                />
                                {showViewAgency && (
                                  <div className="position-absolute box-agency">
                                    <ul className="list-unstyled">
                                      <li>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="filter..."
                                          onChange={(e) => filterAgency(e)}
                                        />
                                      </li>
                                      {Uens_data &&
                                        Uens_data.filter((data) =>
                                          data.EntityName.toLowerCase().includes(
                                            filterAgency_Value.toLowerCase()
                                          )
                                        ).map((data, index) => {
                                          return (
                                            <li
                                              key={index}
                                              onClick={() =>
                                                updateUEN(data.EntityName)
                                              }
                                            >
                                              {data.EntityName}
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col row">
                          <label
                            htmlFor="ResearchTopic"
                            className="col-sm-3 col-form-label text-wrap"
                          >
                            Title of Project / Research Topic
                            <span className="text-danger">*</span>
                            <br>
                            </br>
                          </label>
                          <div className="col-sm-9">
                            <textarea
                              ref={setRef("ResearchTopic")}
                              defaultValue={
                                form_Data ? form_Data.ResearchTopic : ""
                              }
                              id="ResearchTopic"
                              placeholder="What happen in World War II"
                              className="form-control"
                              rows="5"
                              required
                            ></textarea>
                          </div>
                        </div>
                        <div className="col row mt-3">
                          <label className="col-sm-3 col-form-label text-wrap">
                            Expected date of completion:
                          </label>
                          <div className="col-sm-9">
                            <DatePicker
                              selected={date}
                              onChange={updateDate}
                              onBlur={updateDate2}
                              className="form-control"
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              dateFormat="dd/MM/yyyy"
                              placeholderText="dd/mm/yyyy"
                            />
                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                          </div>
                          <label
                            htmlFor="COUCode"
                            className="col-sm-3 col-form-label text-wrap"
                          >
                            Context of Use<span className="text-danger">*</span>
                            :
                          </label>
                          <div className="col-sm-9">
                            <select
                              ref={setRef("COUCode")}
                              id="COUCode"
                              defaultValue={form_Data ? form_Data.COUCode : ""}
                              className="form-control"
                              onChange={(e) => updateCou(e)}
                              required
                            >
                              {contextOf_Use &&
                                contextOf_Use.map((data, index) => {
                                  return (
                                    <option key={index} value={data.Code}>
                                      {data.Description}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        {isVisible &&
                          <div className="col row mt-3">
                            <label htmlFor="OtherRemarks" className="col-sm-3 col-form-label text-wrap">
                              Other Remarks<span className="text-danger">*</span>:
                            </label>
                            <div className="col-sm-9">
                              <textarea
                                ref={setRef("OtherRemarks")}
                                defaultValue={form_Data ? form_Data.OtherRemarks : ''}
                                id="OtherRemarks"
                                className="form-control"
                                rows="5"
                                placeholder="Enter context of use"
                                required
                              ></textarea>
                            </div>
                          </div>
                        }
                        <div className="col row mt-3">
                          <label
                            htmlFor="remarks"
                            className="col-sm-3 col-form-label text-nowrap"
                          >
                            Remarks:
                          </label>
                          <div className="col-sm-9">
                            <textarea
                              placeholder="Please elaborate on the context of use for your requested records and/or provide further details to support your request. e.g. research topic and scope, work product, target audience etc."
                              className="form-control"
                              defaultValue={form_Data ? form_Data.Remarks : ""}
                              rows="5"
                              id="remarks"
                              ref={setRef("remarks")}
                            ></textarea>
                          </div>
                        </div>
                        {/* {process.env.REACT_APP_USERECAPTCHA === "true" && ( */}
                        <div className="input-group mb-3  row mt-4">
                          <div className="col-sm-12 d-flex justify-content-center">
                            <ReCAPTCHA
                              sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                              ref={setRef("recaptcha")}
                            />
                          </div>
                          <div className="col-sm-12 d-flex justify-content-center">
                            {pages_state && !pages_state.isCaptcha && (
                              <div className="text-danger ">
                                <small> Recaptcha is required!</small>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* )} */}
                        <div className="input-group mb-3  row">
                          <div className="col-sm-12 d-flex justify-content-center">
                            <button
                              type="submit"
                              className="btn btn-primary btn-lg me-2"
                            >
                              Submit
                            </button>
                            <Link to={"/"} className="btn btn-secondary btn-lg">
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-md-4 mt-md-0 mt-3">
              {shopping_Cart &&
                shopping_Cart.viewOnsite &&
                shopping_Cart.viewOnsite.items &&
                shopping_Cart.viewOnsite.items.length > 0 && (
                  <div className="card overflow-hidden mb-3">
                    <div className="card-header text-light text-center">
                      <span>Checkout Summary</span>
                      <span className="font-weight-bold text-18 d-block">
                        Request to View On-site
                      </span>
                    </div>
                    <div className="card-body d-flex justify-content-center p-3">
                      <div className="card-content">
                        <div className="summary">
                          {/* <h3>

                                                <i className="fa fa-question-circle" data-placement="top"
                                                    data-content="This request requires processing and may require additional clearance. Refer to FAQ for more information"
                                                    data-trigger="hover" data-animation="am-flip-x" bs-popover></i>
                                            </h3> */}
                          <div>
                            <small>
                              This request requires processing and may require
                              additional clearance. Refer to FAQ for more
                              information
                            </small>
                          </div>
                          <div className="itemAndAAFee-amount font-weight-bold mt-3">
                            <span className="itemAndAAFee">
                              Item
                              {shopping_Cart.viewOnsite.items.length > 1
                                ? "s"
                                : ""}
                              :{shopping_Cart.viewOnsite.items.length}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {shopping_Cart &&
                shopping_Cart.subjectToApproval &&
                shopping_Cart.subjectToApproval.totalItemsCount > 0 && (
                  <div className="card overflow-hidden mb-3">
                    <div className="card-header text-light text-center">
                      <span>Checkout Summary</span>
                      <span className="font-weight-bold text-18 d-block">
                        Request a Copy/Clip:{" "}
                      </span>
                      <span className="font-weight-bold">
                        Subject to Approval{" "}
                      </span>
                    </div>
                    <div className="card-body d-flex justify-content-center p-3">
                      <div className="card-content">
                        <div className="summary">
                          {/* <h3>

                                                <i className="fa fa-question-circle" data-placement="top"
                                                    data-content="This request requires processing and may require additional clearance. Refer to FAQ for more information"
                                                    data-trigger="hover" data-animation="am-flip-x" bs-popover></i>
                                            </h3> */}
                          <div>
                            <small>
                              This request requires approval from third-party
                              copyrights owners. The waiting time will depend on
                              the third-party copyrights owners. Refers to FAQ
                              for more information.
                            </small>
                          </div>

                          <div className="overflow-auto mt-3">
                            <table
                              className="table table_SAAP"
                              style={{ border: 0 }}
                            >
                              <tr>
                                <td>
                                  Item
                                  {shopping_Cart.subjectToApproval
                                    .totalItemsCount > 1
                                    ? "s"
                                    : ""}
                                  :
                                  {
                                    shopping_Cart.subjectToApproval
                                      .totalItemsCount
                                  }
                                </td>
                                <td>
                                  <CurrencyFormat
                                    value={parseFloat(shopping_Cart.subjectToApproval.totalItemsAmount).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Req Admin Fee:{" "}
                                  {
                                    shopping_Cart.subjectToApproval
                                      .accessionNumbers.length
                                  }
                                  <br />
                                  (based on number of Accession No.)
                                  <div className="mt-1">
                                    <div
                                      className="cursor_pointer"
                                      onClick={toggleshowAccession}
                                    >
                                      View List{" "}
                                      <span class="material-icons-outlined align-middle">
                                        {showAccession
                                          ? "expand_less"
                                          : "expand_more"}
                                      </span>
                                    </div>
                                    {showAccession && (
                                      <ul>
                                        {shopping_Cart.subjectToApproval.accessionNumbers.map(
                                          (data, index) => {
                                            return (
                                              <li>
                                                <small>{data}</small>
                                              </li>
                                            );
                                          }
                                        )}
                                      </ul>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <CurrencyFormat
                                    value={parseFloat(shopping_Cart.subjectToApproval.totalAafee).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>Subtotal</td>
                                <td>
                                  <CurrencyFormat
                                    value={parseFloat(shopping_Cart.subjectToApproval.totalItemsAmountAndTotalAafee).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                  />
                                </td>
                              </tr>
                              {cur_POU && cur_POU === "PA" && (
                                <tr>
                                  <td class="text-bold">
                                    Under FCM No.
                                    <br />
                                    M11/2016
                                  </td>

                                  <td>
                                    <del>
                                      <CurrencyFormat
                                        value={parseFloat(shopping_Cart.subjectToApproval.totalItemsAmountAndTotalAafee).toFixed(2)}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                      />
                                    </del>
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td style={{ borderBottom: "1px solid #ddd" }}>
                                  GST ({shopping_Cart.gst})%
                                </td>
                                <td style={{ borderBottom: "1px solid #ddd" }}>
                                  <CurrencyFormat
                                    value={parseFloat(shopping_Cart.subjectToApproval.gstAmount).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}

                                  />
                                </td>
                              </tr>
                              <tr className="text-18">
                                <td>Total w/GST (SGD)</td>
                                <td className="font-weight-bold">
                                  <CurrencyFormat
                                    value={
                                      shopping_Cart.subjectToApproval
                                        .finalAmount > 0
                                        ? parseFloat(shopping_Cart.subjectToApproval
                                          .finalAmount).toFixed(2)
                                        : (0)
                                    }
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}

                                  />
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              {shopping_Cart &&
                shopping_Cart.availableAfterPayment &&
                shopping_Cart.availableAfterPayment.items &&
                shopping_Cart.availableAfterPayment.items.length > 0 && (
                  <div className="card overflow-hidden mb-3">
                    <div className="card-header text-light text-center">
                      <span>Checkout Summary</span>
                      <span className="font-weight-bold text-18 d-block">
                        Request a Copy/Clip:{" "}
                      </span>
                      <span className="font-weight-bold">
                        Available after Payment{" "}
                      </span>
                    </div>
                    <div className="card-body d-flex justify-content-center p-3">
                      <div className="card-content">
                        <div className="summary">
                          {/* <h3>
                                                <i className="fa fa-question-circle" data-placement="top"
                                                    data-content="This request requires processing and may require additional clearance. Refer to FAQ for more information"
                                                    data-trigger="hover" data-animation="am-flip-x" bs-popover></i>
                                            </h3> */}
                          <div>
                            <small>
                              This request will be processed after payment has
                              been made. Refer to FAQ for more information.
                            </small>
                          </div>

                          <div className="overflow-auto mt-3">
                            <table
                              className="table table_SAAP"
                              style={{ border: 0 }}
                            >
                              <tr>
                                <td>
                                  Item
                                  {shopping_Cart.availableAfterPayment.items
                                    .length > 1
                                    ? "s"
                                    : ""}
                                  :
                                  {
                                    shopping_Cart.availableAfterPayment.items
                                      .length
                                  }
                                  <div>
                                    <small class="font-weight-normal">
                                      physical item
                                      {pages_state &&
                                        pages_state.countPhysical > 1
                                        ? "s"
                                        : ""}
                                      :{" "}
                                      {pages_state && pages_state.countPhysical}
                                    </small>
                                  </div>
                                  <div>
                                    <small class="font-weight-normal">
                                      digital item
                                      {pages_state &&
                                        pages_state.countDigital > 1
                                        ? "s"
                                        : ""}
                                      :{" "}
                                      {pages_state && pages_state.countDigital}
                                    </small>
                                  </div>
                                </td>
                                <td>
                                  <CurrencyFormat
                                    value={parseFloat(shopping_Cart.availableAfterPayment.totalItemsAmount).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                  />
                                </td>
                              </tr>
                              {shopping_Cart.availableAfterPayment.totalAafee >
                                0 && (
                                  <tr>
                                    <td>
                                      Req Admin Fee:{" "}
                                      {
                                        shopping_Cart.availableAfterPayment
                                          .accessionNumbers.length
                                      }
                                      <br />
                                      (based on number of Accession No.)
                                      <div className="mt-1">
                                        <div
                                          className="cursor_pointer"
                                          onClick={toggleshowAccession}
                                        >
                                          View List{" "}
                                          <span class="material-icons-outlined align-middle">
                                            {showAccession
                                              ? "expand_less"
                                              : "expand_more"}
                                          </span>
                                        </div>
                                        {showAccession && (
                                          <ul>
                                            {shopping_Cart.availableAfterPayment.accessionNumbers.map(
                                              (data, index) => {
                                                return (
                                                  <li>
                                                    <small>{data}</small>
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <CurrencyFormat
                                        value={parseFloat(shopping_Cart.availableAfterPayment.totalAafee).toFixed(2)}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                      />
                                    </td>
                                  </tr>
                                )}
                              <tr>
                                <td>Subtotal</td>
                                <td>
                                  <CurrencyFormat
                                    value={parseFloat(shopping_Cart.availableAfterPayment.totalItemsAmountAndTotalAafee).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                  />
                                </td>
                              </tr>
                              {cur_POU && cur_POU === "PA" && (
                                <tr>
                                  <td class="text-bold">
                                    Under FCM No.
                                    <br />
                                    M11/2016
                                  </td>

                                  <td>
                                    <del>
                                      <CurrencyFormat
                                        value={parseFloat(shopping_Cart.availableAfterPayment.totalItemsAmountAndTotalAafee).toFixed(2)}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                      />
                                    </del>
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td style={{ borderBottom: "1px solid #ddd" }}>
                                  GST ({shopping_Cart.gst})%
                                </td>
                                <td style={{ borderBottom: "1px solid #ddd" }}>
                                  <CurrencyFormat
                                    value={parseFloat(shopping_Cart.availableAfterPayment.gstAmount).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}

                                  />
                                </td>
                              </tr>
                              <tr className="text-18">
                                <td>Total w/GST (SGD)</td>
                                <td className="font-weight-bold">
                                  <CurrencyFormat
                                    value={parseInt(shopping_Cart.availableAfterPayment.finalAmount) > 0 ? shopping_Cart.availableAfterPayment.finalAmount : (0)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}

                                  />
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
